import "../../../styles/variables.scss";

export const customStyles = {
  control: (base: any) => ({
    ...base,
    background: "$BgColor",
    cursor: "pointer",
    borderRadius: 4,
    height: "46px",
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: "none",
  }),
  menu: (base: any) => ({
    ...base,
    fontWeight: 400,
    fontSize: 14,
    color: "#000",
  }),
  option: (base: any) => ({
    ...base,
    cursor: "pointer",
    padding: "5px 10px",
  }),

  valueContainer: (base: any) => ({
    ...base,
    fontWeight: 400,
    fontSize: 14,
  }),
};
